(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novalux-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-nl-cookie-settings]');
    if (!button) return;
    const status = button.closest('.nl-container').querySelector('[data-nl-cookie-status]');
    status.hidden = true;
    button.disabled = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Privacy controls unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      status.hidden = false;
    } finally {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novalux-qa-responsive"]) return;
  try {
    
document.getElementById('NLQaOpen')?.addEventListener('click',()=>{
 const frame=document.getElementById('NLQaFrame');
 const page=document.getElementById('NLQaPage').value;
 const lang=document.getElementById('NLQaLanguage').value;
 frame.width=document.getElementById('NLQaWidth').value;
 frame.src=lang+(page==='/'?'/':page);
});

  } catch(e) { console.error(e); }
})();
})();
